import { render } from "./ResetPwdModal.vue?vue&type=template&id=b82e32aa"
import script from "./ResetPwdModal.vue?vue&type=script&lang=js"
export * from "./ResetPwdModal.vue?vue&type=script&lang=js"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__